module.exports = __webpack_public_path__ + "static/media/1.f74e4eb3.JPG";